import React from "react";
import { Box, Button, Typography } from "@mui/material";
import PersonConnectionTable from "../../../components/tables/PersonConnectionTable";
import AddIcon from "@mui/icons-material/Add";
import { Person } from "../../../types/person";
import usePersonConnectionController from "../../../controllers/connections/personConnectionController";

interface PersonConnectionsSectionProps {
  person: Person;
}

const PersonConnectionsSection: React.FC<PersonConnectionsSectionProps> = ({
  person,
}) => {
  const controller = usePersonConnectionController({from: person});
  const { openCreateDialog } = controller;
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            mb: 4,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              position: "absolute",
              left: 16,
            }}
            startIcon={<AddIcon />}
            onClick={() => openCreateDialog()}
          >
            New Person Connection
          </Button>
          <Typography variant="h2">Person Connections</Typography>
        </Box>
        <PersonConnectionTable controller={controller} />
      </Box>
    </>
  );
};

export default PersonConnectionsSection;
